import { ReactNode } from 'react';

export const ChaptersNavigatorTitle = ({ children, showHeader }: { children: ReactNode; showHeader: boolean }) => (
    <h2 className={`${showHeader ? 'text-sm font-heading uppercase mx-5 pt-2' : 'sr-only'}`}>
        {children}
    </h2>
);
